import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createAdjustment } from '@store/actions/adjustment.action'
import {
  Adjustment,
  ProcedureAdjustment,
} from '@services/api/billing/adjustment.api'

interface AdjustmentState {
  adjustments: Adjustment[]
  procedureAdjustments: ProcedureAdjustment[]
  loading: boolean
  error: string | null
}

const initialState: AdjustmentState = {
  adjustments: [],
  procedureAdjustments: [],
  loading: false,
  error: null,
}

const adjustmentSlice = createSlice({
  name: 'adjustment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createAdjustment.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        createAdjustment.fulfilled,
        (
          state,
          action: PayloadAction<{
            adjustment: Adjustment
            procedureAdjustments: ProcedureAdjustment[]
          }>,
        ) => {
          state.loading = false
          state.adjustments.push(action.payload.adjustment)
          state.procedureAdjustments.push(
            ...action.payload.procedureAdjustments,
          )
        },
      )
      .addCase(createAdjustment.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export default adjustmentSlice.reducer
